var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-aside',{attrs:{"width":_vm.state.asideWidth}},[_c('nav-menu')],1),_vm._v(" "),_c('el-container',[_c('el-header',{attrs:{"height":"50px"}},[_c('nav-header')],1),_vm._v(" "),_c('el-header',{attrs:{"height":"40px"}},[_c('nav-tag')],1),_vm._v(" "),_c('el-main',[_c('main-content')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202bbd24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/main.vue
// module id = null
// module chunks = 